<template>
	<v-row class="d-flex justify-end">
		<v-col :cols="12" :md="8" :lg="6">
			<v-text-field class="number-tickets" style="max-width: 95px" v-model="internalValue" :disabled="disabled" type="number" @blur="handleChange" autocomplete="null">
				<button @click="handleMinusClick" slot="prepend" class="minus-button" :disabled="internalValue <= min || disabled">
					<v-icon dark> mdi-minus </v-icon>
				</button>

				<button @click="handlePlusClick" slot="append-outer" class="plus-button" :disabled="internalValue >= max || disabled">
					<v-icon dark> mdi-plus </v-icon>
				</button>
			</v-text-field>
		</v-col>
	</v-row>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: () => {
                return Number.MAX_SAFE_INTEGER;
            },
            required: false
        },
        min: {
            type: Number,
            default: () => {
                return Number.MIN_SAFE_INTEGER;
            },
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            internalValue: this.value
        };
    },
    watch: {
        value(val) {
            this.internalValue = val;
        },
        internalValue(newVal) {
            this.$emit('value-changed', newVal);
        }
    },
    methods: {
        handleChange() {
            const val = parseInt(this.internalValue, 10);

            if (!isNaN(val) && val >= this.min && val <= this.max) {
                this.$emit('input', val);
            } else {
                if (val > this.max) {
                    this.internalValue = this.max;
                    this.$emit('input', this.max);
                } else {
                    this.internalValue = this.min;
                    this.$emit('input', this.min);
                }
            }
        },
        handleMinusClick() {
            this.internalValue = this.internalValue - 1;
            this.handleChange();
        },
        handlePlusClick() {
            this.internalValue = this.internalValue + 1;
            this.handleChange();
        }
    }
};
</script>

<style>
.plus-button {
	background: #24a54e;
	border-radius: 3rem;
}

.minus-button {
	background: #575e60;
	border-radius: 3rem;
}
.minus-button:disabled {
	background: #d2d7d9;
}
.plus-button:disabled {
	background: #d2d7d9;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
	text-align: center;
}

/* Firefox */
input[type='number'] {
	-moz-appearance: textfield;
	text-align: center;
}
</style>
